import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { getLogo } from '../../../../lib/logoConfig';
import {
  LogoSection,
  LogoBox,
  LogoBrand,
  LogoCountry,
  LogoTextWrapper,
  LogoText,
  Subtitle,
  BackButton,
} from './Logo.style';

const Logo = ({ onNavigateHome, showBackButton, onBack, backLabel }) => {
  const { i18n } = useTranslation();
  const logo = getLogo(i18n.language, true);

  return (
    <>
      <LogoSection onClick={onNavigateHome}>
        <LogoBox>
          <LogoBrand>PORSCHE</LogoBrand>
          {logo.countryName && <LogoCountry>{logo.countryName}</LogoCountry>}
        </LogoBox>
        <LogoTextWrapper>
          <LogoText><span>COPS</span></LogoText>
          <Subtitle>Online Portal</Subtitle>
        </LogoTextWrapper>
      </LogoSection>
      {showBackButton && (
        <BackButton onClick={onBack}>
          <i className="mdi mdi-arrow-left" />
          {backLabel}
        </BackButton>
      )}
    </>
  );
};

Logo.propTypes = {
  onNavigateHome: PropTypes.func.isRequired,
  showBackButton: PropTypes.bool,
  onBack: PropTypes.func,
  backLabel: PropTypes.string,
};

export default Logo;
